import React from "react"
import {WithBranding} from "@irati/brand/withBranding"
import {Deal} from "@irati/types"
import {connect} from "@irati/store"
import Desktop from "./Desktop"
import Mobile from "./Mobile"

export interface HeaderProps extends WithBranding {
  id?: string,
  deal: Deal
}

interface Props extends HeaderProps {
  isMobile: boolean
}

const Header: React.FC<Props> = ({isMobile, ...props}) => {
  if (isMobile) {
    return <Mobile {...props} />
  }

  return <Desktop {...props} />
}

const mapStateToProps = ({mq}: any) => ({isMobile: mq.lessThan.md})

export default connect(mapStateToProps)(Header)
